import { desc } from "framer-motion/client";

export const EXPERIENCE = [
  {
    id: 'yooz',
    role: 'Web Developer',
    company: 'Yooz',
    period: 'Aug 2025 – Feb 2026',
    points: [
      'Enhanced and maintained web applications using Python, React, and Angular.',
      'Built automated CI/CD pipelines that reduced deployment cycle time by 25%.',
      'Worked with clients to gather requirements, delivering features 10% faster than projected deadlines.',
      'Collaborated in agile teams to ship scalable solutions.',
    ],
  },
  /*{
    id: 'moona',
    role: 'Software Developer (Student)',
    company: 'Moona Space',
    period: 'Jan 2024 – Oct 2024',
    points: [
      'Developed an Android application from scratch to interface with custom-built drones.',
      'Engineered a communication layer between the mobile app and Arduino-based controllers for real-time connectivity.',
      'Gained hands-on experience in real-time systems and embedded software using Java, C, and Arduino.',
    ],
  },*/
];

export const EDUCATION = [
  {
    id: 'ariel',
    title: 'B.Sc. Computer Science and Mathematics',
    place: 'Ariel University',
    period: '2021 – 2025',
  },
];

export const CERTIFICATIONS = [
  {
    id: 'microservices',
    title: 'Microservices Development and DevOps',
    place: 'MS&T',
    period: '2026',
    detail: '250 academic hours',
  },
];

export const SKILL_GROUPS = [
  {
    group: 'Programming',
    items: ['Java', 'JavaScript', 'TypeScript', 'Python', 'HTML', 'CSS', 'Bash', 'C'],
  },
  {
    group: 'Frameworks',
    items: ['Spring Boot', 'React', 'Angular', 'REST APIs', 'Swagger'],
  },
  {
    group: 'Databases',
    items: ['MySQL', 'MongoDB'],
  },
  {
    group: 'Microservices & Cloud',
    items: ['AWS', 'Google Cloud', 'API Gateway', 'Load Balancing'],
  },
  {
    group: 'DevOps & Deployment',
    items: ['Docker', 'Kubernetes', 'Jenkins (CI/CD)'],
  },
  {
    group: 'Tools & Platforms',
    items: ['Linux', 'Git', 'GitHub', 'BitBucket', 'Postman', 'Kafka', 'JSON'],
  },
  {
    group: 'AI-Augmented Development',
    items: ['Copilot', 'Cursor'],
  },
];

const PROJECTS = [
  {
    id: 'AlertHub-web',
    title: 'AlertHub',
    desc: 'AlertHub is a microservices platform for ingesting developer-task data from GitHub, Jira, and ClickUp, evaluating metrics against configurable thresholds, and dispatching email or SMS alerts when conditions are met',
    cover: null,
    tags: ['Java SpringBoot', 'MYSQL', 'MongoDB', 'Microservices', 'Kafka', 'Docker', 'RESTAPI', 'nginx', 'React'],
    featured: true,
    codeUrl: 'https://github.com/IbrahemHurani/AlertHub',
    liveUrl: null,
    accent: '#ff6b4a'


  },
  {
    id: 'dji-drone',
    title: 'Mini Drone Simulation',
    desc: 'Android autonomous navigation with DJI SDK and Google Maps — Virtual Stick controls, real-time waypoints, and Observer-pattern state sync.',
    cover: 'Drone-image.jpeg',
    tags: ['Java', 'Android', 'DJI SDK', 'Maps'],
    liveUrl: 'https://www.youtube.com/watch?v=781JmPTZTJc',
    codeUrl: 'https://github.com/IbrahemHurani/Mini-Drone-Simulation',
    accent: '#ff6b4a',
  },
  {
    id: 'hells-paradise',
    title: 'Hells Paradise',
    desc: 'A 3D action game built in Unity with custom systems, polished UI, and immersive gameplay.',
    cover: 'End-image.jpeg',
    tags: ['C#', 'Unity', '3D', 'UI/UX'],
    liveUrl: 'https://ibrahem-hurani.itch.io/hells-paradise-3d',
    codeUrl: 'https://github.com/CourseGamedeveloper/Hells-Paradise',
    accent: '#e8a06a',
  },
  {
    id: 'fair-division',
    title: 'Fair Division Platform',
    desc: 'Research-backed web platform implementing worst-case fair division algorithms.',
    cover: null,
    tags: ['JavaScript', 'Python', 'Flask', 'Research'],
    liveUrl: 'https://ibrahemhurani.csariel.xyz/',
    codeUrl: 'https://github.com/IbrahemHurani/markakis_psomas_web',
    accent: '#f0c75e',
  },
  {
    id: 'book-now',
    title: 'BOOK-NOW',
    desc: 'Android app for booking and managing appointments with a clean, practical workflow.',
    cover: null,
    tags: ['Java', 'Android', 'Firebase', 'SDK'],
    liveUrl: 'https://github.com/yousefmasarwa97/Book_Now',
    codeUrl: 'https://github.com/yousefmasarwa97/Book_Now',
    accent: '#4ecdc4',
  },
  {
    id: 'chat-room',
    title: 'Chat Room',
    desc: 'Real-time client-server chat over TCP/UDP with a clear networking architecture.',
    cover: null,
    tags: ['Python', 'TCP', 'UDP', 'Networking'],
    liveUrl: 'https://www.youtube.com/watch?v=0onQCSt8kuE',
    codeUrl: 'https://github.com/IbrahemHurani/Chat_ROOM',
    accent: '#7aa2ff',
  },
  {
    id: 'target-drop',
    title: 'Target Drop Game',
    desc: 'Drop the ball and aim for the center — a precision web game with Firebase backend.',
    cover: null,
    tags: ['Angular', 'TypeScript', 'Firebase', 'UI/UX'],
    liveUrl: 'https://github.com/IbrahemHurani/Target-Drop',
    codeUrl: 'https://github.com/IbrahemHurani/Target-Drop',
    accent: '#c084fc',
  },
];

export default PROJECTS;
